import { useCallback } from 'react';
import { useIvrMenu } from '@/hooks/useSwitchboard';

export function useIvrLabel() {
  const { data: ivrMenu } = useIvrMenu();

  const ivrLabel = useCallback((digit: string | null | undefined): string | null => {
    if (!digit) return null;
    const option = ivrMenu?.options?.find((o: { digit: string; label: string }) => o.digit === digit);
    return option?.label || `Tast ${digit}`;
  }, [ivrMenu]);

  return ivrLabel;
}
